import { render, staticRenderFns } from "./ui-task-header-component.vue?vue&type=template&id=97bafa0a&scoped=true&"
import script from "./ui-task-header-component.vue?vue&type=script&lang=ts&"
export * from "./ui-task-header-component.vue?vue&type=script&lang=ts&"
import style0 from "./ui-task-header-component.vue?vue&type=style&index=0&id=97bafa0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bafa0a",
  null
  
)

export default component.exports